import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useSelector, useDispatch } from 'react-redux'
import { Snackbar as MuiSnackbar, Box, Typography, IconButton } from '@mui/material'

const Snackbar = () => {
  const dispatch = useDispatch()
  const snackbarState = useSelector((state: any) => state.snackbar)

  const handleClose = () => {
    dispatch({ type: 'CLOSE_SNACKBAR' })
  }

  // « green » et « red » sont les valeurs passées par la plupart des pages
  // (environ 250 appels) : elles n'étaient pas reconnues (Z1-22).
  const couleur = String(snackbarState.color ?? '').toLowerCase()
  const isSuccess = couleur === 'green' || couleur.includes('success') || couleur === '#34d399' || couleur.includes('4caf') || couleur.includes('2e7d')
  const isError = couleur === 'red' || couleur.includes('error') || couleur === '#f87171' || couleur.includes('d32f')

  const icon = isSuccess
    ? <CheckCircleOutlineRoundedIcon sx={{ fontSize: 18, color: 'var(--c-success)' }} />
    : isError
    ? <ErrorOutlineRoundedIcon sx={{ fontSize: 18, color: 'var(--c-error)' }} />
    : <InfoOutlinedIcon sx={{ fontSize: 18, color: 'var(--c-text-primary)' }} />

  const borderColor = isSuccess ? 'var(--c-success)' : isError ? 'var(--c-error)' : 'var(--c-text-primary)'

  return (
    <MuiSnackbar
      onClose={handleClose}
      autoHideDuration={3500}
      open={snackbarState.open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        background: 'var(--c-surface)',
        border: '1.5px solid var(--c-text-primary)',
        borderLeft: `6px solid ${borderColor}`,
        borderRadius: 'var(--radius-sm)',
        px: 2,
        py: 1.5,
        minWidth: '280px',
        maxWidth: '420px',
        fontFamily: 'var(--font-body)',
      }}>
        {icon}
        <Typography sx={{
          flex: 1,
          fontFamily: 'var(--font-body)',
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--c-text-primary)',
        }}>
          {snackbarState.message}
        </Typography>
        <IconButton size="small" onClick={handleClose} sx={{ color: 'var(--c-text-muted)', '&:hover': { color: 'var(--c-text-secondary)' } }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </MuiSnackbar>
  )
}

export default Snackbar
